var dadk = {
	"coupon-callout": {
	"coupon-code": "Rabatkode",
	"coupon-message-with-price": "Du skal bare {{ price }}",
	"coupon-expiry-message": "Udløber {{ Date }}.",
	"code-at-checkout": "Indtast rabatkoden ved kassen. Kan ikke kombineres med andre rabatkoder, kampagner eller rabatter.",
	"cancel-icon": "Annuller",
	"info-icon": "Se yderligere oplysninger",
	"check-icon": "Anvendt",
	"promo-code": "Rabatkode",
	"coupon-callout-popover": "Popover-kupon"
}
};

export { dadk as default };
//# sourceMappingURL=src-localization-texts-da-dk.json.js.map
